import { TemplateData, TemplateParams } from '.';

const achievementExpiring = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{achievementUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementExpiringContent} {{expirationDate}}.
        ${messages.achievementExpirationInfo}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.achievementExpiring}`
  },
  placeholders: {
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    achievementUrl: {
      label: messages.achievementLink,
      example: `${serverConfig.adminUrl}/achievements/1`
    },
    expirationDate: {
      label: messages.commonExpirationDate,
      example: '27.3.2024'
    },
    expirationTimeInDays: {
      label: messages.siteSettingsAccountExpirationTimeInDays,
      example: '3'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeExternalAchievementExpiring
});

export default achievementExpiring;
